/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Lightweight macrotask queue so independent init blocks below run as
// separate yielded tasks instead of one long synchronous chain - keeps
// any single task under long-task thresholds without changing what any
// block does or the relative order they run in.
var __taskQueue = [];
var __taskQueueScheduled = false;
function __runNextTask() {
  var task = __taskQueue.shift();
  if (task) task();
  if (__taskQueue.length) {
    setTimeout(__runNextTask, 0);
  } else {
    __taskQueueScheduled = false;
  }
}
function scheduleTask(fn) {
  __taskQueue.push(fn);
  if (!__taskQueueScheduled) {
    __taskQueueScheduled = true;
    setTimeout(__runNextTask, 0);
  }
}

// Forces the market/language dropdown's flag <img>s to fetch only once the
// dropdown actually becomes visible, instead of at page load while it's
// still closed. IntersectionObserver reliably fires when an element goes
// from display:none (no box) to visible (a box that overlaps the
// viewport), which is exactly the append()-then-open sequence these flags
// go through - so this keeps them off the network until actually needed.
function watchFlagsUntilVisible(containers) {
  function eagerLoadFlags() {
    containers.forEach(function (container) {
      container.querySelectorAll("img.select-popout__flag").forEach(function (img) {
        img.loading = "eager";
      });
    });
  }

  var el = containers[0];
  if (!el || !("IntersectionObserver" in window)) {
    eagerLoadFlags();
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        eagerLoadFlags();
        observer.disconnect();
      }
    });
  });
  observer.observe(el);
}

/*
  Stand-ins for the two jQuery behaviours this file relied on, now that jQuery
  is gone from the theme.

  onReady: custom.js is deferred, so the document has normally finished parsing
  by the time this runs.

  The setTimeout is deliberate and must stay. jQuery's $(document).ready() did
  NOT invoke its callback synchronously on an already-parsed document - it
  deferred via window.setTimeout - and the scheduleTask blocks below depend on
  that. The block registering the cart handlers calls onReady, so its
  registration used to land one macrotask later, i.e. AFTER the PLP/routine
  handlers in the following scheduleTask block. Running it synchronously flips
  that order, and the order is load-bearing: a PLP card's add button matches both
  the generic "button.product__submit__add" handler and the PLP-specific one, so
  a single click fires cartGiftUpdate twice and whichever registered first wins
  the /cart/update.js race.

  parseSectionHtml: $(htmlString) parsed a Section Rendering API response into a
  detached tree to read pieces out of. A <template> is used because it parses the
  markup without fetching images or running scripts, and the section HTML being
  read here contains neither.
*/
function onReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    setTimeout(callback, 0);
  }
}

function parseSectionHtml(html) {
  var holder = document.createElement("template");
  holder.innerHTML = html;
  return holder.content;
}

/*
  Replaces a container's contents AND runs any <script> it contains.

  This is the part of jQuery's .html() that innerHTML alone does not do, and the
  cart drawer depends on it. snippets/devx-cart-progress-bar.liquid renders an
  inline <script> inside #cart-drawer which sets window.cartTotal from Liquid and
  calls initProgressBar() to size the GWP progress bar; its own comment describes
  its globals as persisting "across initProgressBar() re-runs", i.e. it is meant
  to re-execute every time this markup is swapped in. Assigning innerHTML leaves
  that script inert, so the bar keeps the width: 0% it gets from theme.css and
  renders as an empty track no matter what is in the cart.

  A script inserted via innerHTML is flagged "already started" and never runs, so
  each one has to be swapped for a fresh element. querySelectorAll returns them in
  document order, which is the order jQuery evaluated them in.
*/
function setHtmlAndRunScripts(target, html) {
  target.innerHTML = html;

  target.querySelectorAll("script").forEach(function (oldScript) {
    var newScript = document.createElement("script");
    Array.prototype.forEach.call(oldScript.attributes, function (attr) {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

// The open/close pair is toggled from several places (the cart icon, the close
// button, the overlay, an outside click, and cartGiftUpdate after a cart update),
// so it lives here at top level rather than being repeated at each call site.
function openCartDrawer() {
  var cartDrawer = document.getElementById("cart-drawer");
  if (cartDrawer) cartDrawer.classList.add("is-open");
  document.body.classList.add("js-drawer-open-cart");
}

function closeCartDrawer() {
  var cartDrawer = document.getElementById("cart-drawer");
  if (cartDrawer) cartDrawer.classList.remove("is-open");
  document.body.classList.remove("js-drawer-open-cart");
}

onReady(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("iphone")) {
      document.body.classList.add("iphone-style");
    } else if (userAgent.includes("android")) {
      document.body.classList.add("android-style");
    }
  });

  // Get the current URL
  var currentUrl = window.location.href;

  // Check if the URL is already the Arabic version
  if (currentUrl.includes("/ar")) {
    // Do nothing; we're already on the Arabic page
    document
      .querySelectorAll('.disclosure__link[data-value="ar"]')
      .forEach(function (link) {
        link.classList.add("disclosure__link--active");
      });
  } else {
    // Get the browser's language
    var userLang = navigator.language || navigator.userLanguage;
    var defaultLang = userLang.startsWith("ar") ? "ar" : "en";

    // Base URL with query parameters
    var baseUrl = "https://www.aiza.co/?_ab=0&_fd=0&_sc=1";

    // Redirect based on the default language
    if (defaultLang === "ar") {
      if (currentUrl.includes("?redirection=false")) {
      } else {
        window.location.href = baseUrl.replace("www.aiza.co", "www.aiza.co/ar");
      }
    } else {
      // Set active link to English if in English mode
      document
        .querySelectorAll('.disclosure__link[data-value="en"]')
        .forEach(function (link) {
          link.classList.add("disclosure__link--active");
        });
    }
  }

  document.querySelectorAll(".disclosure__link").forEach(function (disclosureLink) {
    disclosureLink.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent default anchor click behavior

    // Base URL with query parameters
    var baseUrl = window.location.href;

    // Get the language value
    var lang = disclosureLink.dataset.value;

    // Construct the new URL with query parameters
    if (baseUrl.indexOf("/ar") == -1) {
      var replace_with = "/ar" + window.location.pathname;
    } else {
      var replace_with =
        window.location.pathname === "/" ? "" : window.location.pathname;
    }

    var newUrl =
      lang === "ar"
        ? window.location.pathname === "/"
          ? window.location.origin + "/ar" + "?redirection=false"
          : window.location.href.indexOf("/en") == -1
          ? window.location.origin +
            "/ar" +
            window.location.pathname +
            "?redirection=false"
          : window.location.origin +
          window.location.pathname
              .replace("/en-sa", "/ar-sa")
              .replace("/en-qa", "/ar-qa")
              .replace("/en-us", "/ar-us") +
              "?redirection=false"
        : window.location.origin +
          window.location.pathname
              .replace("/ar-sa", "/en-sa")
              .replace("/ar-qa", "/en-qa")
              .replace("/ar-us", "/en-us")
              .replace("/ar", "") +
              "?redirection=false";

    // Redirect to the new URL
    window.location.href = newUrl;

    // Remove active class from all links
    document.querySelectorAll(".disclosure__link").forEach(function (link) {
      link.classList.remove("disclosure__link--active");
    });

    // Add active class to the clicked link
    disclosureLink.classList.add("disclosure__link--active");
    });
  });
});

// $('body').on("click", ":not(#nav-drawer)", function (e) {
//   console.log("Click detected on an element outside #nav-drawer.");
// });
scheduleTask(function () {
document.body.addEventListener("click", function (e) {
  if (!(e.target instanceof Element) || !e.target.closest("div.shopify-section-header")) {
    var navDrawer = document.getElementById("nav-drawer");
    if (navDrawer) navDrawer.style.display = "none";
    document.body.classList.remove("overflow-y-hidden");
  }
});
// documentElement.clientWidth is what $(window).width() returned - it excludes
// the scrollbar, which innerWidth would include.
// Below 1200px the market selector goes into the menu drawer; from 1200px
// into the desktop bar's #HeaderLanguageList (classic and light header alike -
// the light bar shows EN | AR + the market flag on the right).
if (document.documentElement.clientWidth < 1200) {
  setTimeout(function () {
    var county_selectore = Array.from(document.querySelectorAll("form.localization-form"));
    // Appended into the drawer's own #HeaderLanguageList (the same element
    // EN/AR live in) rather than a separate container, so it picks up the
    // exact same flex-row layout/spacing/divider styling the desktop version
    // already gets from #NavStandard #HeaderLanguageList below - same
    // structure both places, just a different #HeaderLanguageList instance.
    var drawerLanguageList = document.querySelector("#nav-drawer #HeaderLanguageList");
    if (drawerLanguageList) {
      // appendChild moves the form, matching what jQuery's append() did.
      county_selectore.forEach(function (form) {
        drawerLanguageList.appendChild(form);
      });
    }
    // The flag <img>s use loading="lazy"; the browser decides whether to fetch
    // them based on their position at initial page load, while they're still
    // sitting in the footer. Moving them here via append() doesn't reliably
    // trigger a re-check in every browser, so they can end up never loading.
    // Rather than forcing eager immediately (which fetches them at page load
    // even though the dropdown is still closed), watch for the dropdown to
    // actually become visible and only force the fetch then.
    watchFlagsUntilVisible(county_selectore);
    var countryList = null;
    county_selectore.some(function (form) {
      countryList = form.querySelector(".select-popout--country .select-popout__list");
      return countryList !== null;
    });

    var drawer = document.getElementById("nav-drawer");
    if (countryList && drawer) {
      var originalStyle = drawer.getAttribute("style") || "";
      var wasHidden = window.getComputedStyle(drawer).display === "none";
      if (wasHidden) {
        drawer.style.display = "block";
        drawer.style.visibility = "hidden";
        drawer.style.position = "fixed";
        drawer.style.top = "-9999px";
      }
      var originalListHeight = countryList.style.height;
      countryList.style.height = "auto";
      // outerHeight(true) included vertical margins, which offsetHeight does not.
      var listStyle = window.getComputedStyle(countryList);
      var neededSpace =
        countryList.offsetHeight +
        parseFloat(listStyle.marginTop || 0) +
        parseFloat(listStyle.marginBottom || 0) +
        40;
      countryList.style.height = originalListHeight;
      if (wasHidden) {
        drawer.setAttribute("style", originalStyle);
      }
      drawer.style.setProperty("--market-dropdown-reserved-space", neededSpace + "px");
    }
  }, 500);
} else {
  setTimeout(function () {
    var county_selectore = Array.from(document.querySelectorAll("form.localization-form"));
    var navLanguageList = document.querySelector("#NavStandard #HeaderLanguageList");
    if (navLanguageList) {
      county_selectore.forEach(function (form) {
        navLanguageList.appendChild(form);
      });
    }
    watchFlagsUntilVisible(county_selectore);
  }, 500);
}

document.addEventListener("click", function (e) {
  if (!(e.target instanceof Element)) return;
  var strong = e.target.closest(".ingredients-new-page .image-with-text__text p strong");
  if (!strong) return;

  var paragraph = strong.closest("p");
  var active_or_not = paragraph ? paragraph.classList.contains("active") : false;
  document
    .querySelectorAll(".ingredients-new-page .image-with-text__text p")
    .forEach(function (p) {
      p.classList.remove("active");
    });
  if (!active_or_not && paragraph) {
    paragraph.classList.add("active");
  }
});

// if($( window ).width() < 767){
//   setTimeout(function() {
//     var app_county_selectore = $('.bacurr-cur-blocker');
//     $(".Mobile-menu-content-container-section").append(app_county_selectore);
//   }, 1000);
// }else{
//   setTimeout(function() {
//     var app_county_selectore = $('.bacurr-cur-blocker');
//     $("#NavStandard #HeaderLanguageList").append(app_county_selectore);
//   }, 1000);
// }
if (document.body.matches(".template-product")) {
  // passive: this only reads scroll position and never preventDefault()s.
  window.addEventListener(
    "scroll",
    function () {
      var footer = document.getElementById("SiteFooter");
      if (!footer) return;
      // $(window).height() was documentElement.clientHeight, and .position().top
      // is the offset from the offsetParent - i.e. offsetTop.
      var scroll = window.pageYOffset + document.documentElement.clientHeight;
      var footer_pos = footer.offsetTop;
      document
        .querySelectorAll(".custom_submit_btn.product__submit__item")
        .forEach(function (btn) {
          btn.classList.toggle("hide", scroll >= footer_pos);
        });
    },
    { passive: true }
  );
}
});

var user_cart = null;
// Set by the main PDP Add to Cart click: cartGiftUpdate() then opens the cart
// drawer and shows the "Added to cart" toast (snippets/pdp-floating-cart.liquid)
// inside it. Cleared once that add finishes or fails.
var pdpCartToastPending = false;
// var user_cart stays at top-level scope (not inside scheduleTask) since
// cartGiftUpdate() reads it via closure - only the fetch that populates it
// is deferred, the declaration itself must not become function-scoped.
scheduleTask(function () {
if (window.location.pathname != "/cart") {
  fetch("/cart.js")
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      user_cart = cart;
      cartGiftUpdate();
    })
    .catch(function (error) {
      console.error("Error fetching the cart:", error);
    });
}
});

scheduleTask(function () {
onReady(function () {
  /*
    Replaces jQuery's delegated $(document).on("click", selector, handler). The
    `delegateClick` helper keeps the same semantics: match the closest ancestor
    of the click target (including the target itself) against the selector, and
    call the handler with that element as `this`.
  */
  function delegateClick(selector, handler) {
    document.addEventListener("click", function (e) {
      if (!(e.target instanceof Element)) return;
      var match = e.target.closest(selector);
      if (match) handler.call(match, e);
    });
  }

  // Reads an input's value from the button's own form, the way
  // $(this).parents("form").find(...).val() did.
  function formInputValue(button, name) {
    var form = button.closest("form");
    var input = form ? form.querySelector('input[name="' + name + '"]') : null;
    return input ? input.value : undefined;
  }

  delegateClick(
    "button.product__submit__add, button.product-upsell__btn",
    function (e) {
      e.preventDefault();
      var product_handle = this.getAttribute("data-handle");
      var upsell_products = this.getAttribute("upsell-products");
      var product_id = formInputValue(this, "id");
      var quantityValue = formInputValue(this, "quantity");
      var product_qty = quantityValue !== undefined ? parseInt(quantityValue) : 1;
      var product_price = formInputValue(this, "price");

        setCartUpsell(upsell_products);

      // Only the main PDP button (desktop and mobile), and only when the toast is on the page.
      pdpCartToastPending = Boolean(
        this.closest(".product-des-wrapper .atc-quantity") &&
          document.querySelector("[data-pdp-cart-toast]")
      );

      cartGiftUpdate(product_id, product_price, product_qty, product_handle, "ADD_TO_CART");
    }
  );
  delegateClick(
    "a.dev_cart_icon_click,a.mobile-menu__button.cart__toggle",
    function (e) {
      e.preventDefault();
      openCartDrawer();

      // Load upsell products when cart drawer opens
      loadUpsellProducts();
    }
  );
  delegateClick("a.cart-drawer__close", function (e) {
    e.preventDefault();
    closeCartDrawer();
  });

  // Desktop: close cart when overlay is clicked
  delegateClick("#cart-drawer-overlay.cart-drawer-overlay", function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeCartDrawer();
  });

  // Close cart when clicking outside (mobile or fallback; overlay handles desktop)
  document.addEventListener("mousedown", function (e) {
    var cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer || !cartDrawer.classList.contains("is-open")) return;
    if (!(e.target instanceof Element)) return;
    if (e.target.closest("#cart-drawer-overlay")) return; // overlay click closes via its handler
    if (e.target.closest("#cart-drawer")) return;
    if (e.target.closest("[data-sample-picker-overlay]")) return;
    if (e.target.closest("[data-cart-drawer-toggle]")) return;
    closeCartDrawer();
  });

  //     $(document).on("click","a.cart-remove-button",function(e) {
  //       e.preventDefault();
  //       var product_id = $(this).parents('.CartDrawer-Item').attr('data-variant-id');
  //       var product_qty = $(this).parents('.CartDrawer-Item').attr('data-quantity');
  //       var product_price = $(this).parents('.CartDrawer-Item').attr('data-price');
  //       cartGiftUpdate(product_id, product_price, product_qty, "REMOVED_FROM_CART");
  //     });
  delegateClick(
    "#cart-drawer .cart__item__quantity button",
    function (e) {
      e.preventDefault();
      var cartItem = this.closest(".cart__item");
      if (!cartItem) return;
      var product_id = cartItem.getAttribute("data-variant-id");
      var product_price = cartItem.getAttribute("data-price");
      var product_handle = cartItem.getAttribute("data-item-handle");
      var upsell_products = cartItem.getAttribute("data-item-upsell");
      var button_type = this.getAttribute("name");
      setCartUpsell(upsell_products);
      if (button_type == "plus") {
        cartGiftUpdate(product_id, product_price, 1, product_handle, "ADD_TO_CART");
      } else {
        cartGiftUpdate(product_id, product_price, 1, product_handle, "REMOVED_FROM_CART");
      }
    }
  );
});
});

function getCurrentTime(message) {
  var message = message ? message : "";
  let now = new Date();
  let formattedTime =
    now.getHours() +
    ":" +
    now.getMinutes() +
    ":" +
    now.getSeconds() +
    ":" +
    now.getMilliseconds();
  console.log(message, formattedTime);
}

window.addEventListener("quinn:atc", () => {
  console.log("quinn:atc event triggered");

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      window.user_cart = cartData;
      console.log("cartData", cartData);
      const cartItems = cartData.items;
      
      if (cartItems.length === 0) {
        console.warn("Cart is empty. Nothing to update.");
        return;
      }

      const sortedItems = [...cartItems].sort((a, b) => {
        return new Date(b.added_at) - new Date(a.added_at);
      });
 
      let latestItem = sortedItems[0];
      if (latestItem.handle.toLowerCase().includes("gwp") && sortedItems.length > 1) {
        latestItem = sortedItems[1]; 
      }
      
      console.log("latestItem", latestItem);
      
      const variantId = latestItem.id.toString();
      const price = latestItem.final_price; // in cents
      const quantity = latestItem.quantity;
      const eventType = "ADD_TO_CART";
      
      // ⏳ Add small delay before reading handle + upsell
      setTimeout(() => {
        const handle = latestItem.handle;
        const metafields = JSON.parse(
          document.getElementById("product-metafields").textContent
        );
        const upsellProds = metafields[handle]?.upsell_products || [];
      
        console.log("Triggering cartGiftUpdate with:", {
          variantId,
          price,
          quantity,
          eventType,
          handle,
          upsellProds,
        });
      
        // Pass `cartData` as the 5th parameter
        setCartUpsell(upsellProds);
        cartGiftUpdate(variantId, price, 0, handle, eventType, cartData, true);
      }, 300); // delay in ms (tweak if needed)      
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
});

// Picks the gift variants for the active market (get_y_uae/sar/int), falling
// back to the shared get_y field when the market-specific one is empty.
function getMarketFieldSuffixes() {
  if (window.activeMarket == "KSA" || window.activeMarket == "SA") return ["sar"];
  if (window.activeMarket == "QAT" || window.activeMarket == "QA") return ["qar", "uae"];
  if (window.activeMarket == "UAE" || window.activeMarket == "AE") return ["uae"];
  return ["int"];
}

function getMarketField(rule, field) {
  var suffixes = getMarketFieldSuffixes();
  for (var i = 0; i < suffixes.length; i++) {
    var value = rule[field + "_" + suffixes[i]];
    var isEmpty = value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0);
    if (!isEmpty) return value;
  }
  return undefined;
}

function getMarketTriggerPrice(rule) {
  return getMarketField(rule, "trigger_price");
}

function getMarketGwpVariants(rule) {
  var marketVariants = getMarketField(rule, "get_y");
  return marketVariants && Array.isArray(marketVariants) && marketVariants.length > 0
    ? marketVariants
    : rule.get_y;
}

// Helper function to extract all GWP variant IDs from metaobject rules
function getAllGwpVariantIds(rules) {
  const gwpIds = new Set();
  if (!rules || !Array.isArray(rules)) return gwpIds;

  rules.forEach(rule => {
    const variants = getMarketGwpVariants(rule);
    if (variants && Array.isArray(variants)) {
      variants.forEach(variantUrl => {
        const variantId = variantUrl.split('/').pop();
        if (variantId) gwpIds.add(variantId);
      });
    }
  });

  return gwpIds;
}

function cartGiftUpdate(
  variantId,
  price,
  quantity,
  handle,
  event,
  customCart,
  isQuinn
) {
  getCurrentTime("start time");
  console.log("cartGiftUpdate", variantId, price, quantity, event, handle);
  const cart = customCart ? customCart : user_cart;
  let isQuin = isQuinn ? isQuinn : false;
  console.log("isQuinn", isQuin);
  let filteredObjects = [];
  try {
    filteredObjects = JSON.parse(document.body.getAttribute("metaobject"));
  } catch (err) {
    console.error(
      "Invalid metaobject JSON:",
      err,
      document.body.getAttribute("metaobject")
    );
  }
  const applicableCoupons = cart.discount_codes?.filter(dc => dc.applicable);
  // Note: loadUpsellProducts() is now called after cart drawer HTML is updated

  let cartProductUpdated = {};
  let totalFreeProdCount = 0;

  // GWP threshold follows the amount actually paid (after discount codes),
  // matching the cart-drawer display (total_cart_price = cart.total_price).
  var cartTotalPrice = cart.total_price;

  let cartConfetti = "";

  // Get all GWP variant IDs dynamically from metaobject rules
  const gwpVariantIds = getAllGwpVariantIds(filteredObjects);
  
  // Update cart product quantities and identify freebies and remove freebies
  var free_gift_quantity = 1;
  cart.items.forEach(function (value) {
    const productId = value.id.toString();
    const productQuantity = value.quantity;

    cartProductUpdated[productId] = cartProductUpdated[productId]
      ? cartProductUpdated[productId]
      : productQuantity;

    var flag = true;
    // Check if this product is a GWP (freebie) using handle detection
    if (value.properties && value.properties._free_sample) {
      totalFreeProdCount += productQuantity;
      cartTotalPrice = cartTotalPrice - value.final_line_price;
    } else if (value.handle && value.handle.toLowerCase().includes('gwp')) {
      totalFreeProdCount++;
      cartProductUpdated[productId] = 0; // Exclude freebies from the product count
      cartTotalPrice = cartTotalPrice - value.final_line_price;
    }
  });

  console.log(cartTotalPrice, "cartTotalPrice 1111111");

  const cartTotalWithoutFreebie = cart.item_count - totalFreeProdCount;

  const effectiveQuantity = Math.max(Number(quantity), 1);

  console.log(effectiveQuantity, "effectiveQuantity");

  // Find the most applicable rule from the metaobject

  let adjustedCartTotal =
    cartTotalWithoutFreebie +
  (event === "ADD_TO_CART"
    ? 1
    : event === "REMOVED_FROM_CART"
    ? -effectiveQuantity
    : event === "ADD_ALL_TO_CART"
    ? variantId.length
    : 0); // Adjust based on the number of items in the cart

let adjustedCartTotalPrice =
  Number(cartTotalPrice) +
  (event === "ADD_TO_CART"
    ? effectiveQuantity * Number(price)
    : event === "REMOVED_FROM_CART"
    ? -effectiveQuantity * Number(price)
    : event === "ADD_ALL_TO_CART"
    ? effectiveQuantity * Number(price)
    : 0);

  if (isQuin) {
    adjustedCartTotalPrice = cartTotalPrice;
  }

  console.log(adjustedCartTotalPrice, "aaa cartTotalPrice 1111111");
  console.log("Cart calculation debug:", {
    originalSubtotal: cart.items_subtotal_price,
    cartTotalPrice: cartTotalPrice,
    adjustedCartTotalPrice: adjustedCartTotalPrice,
    event: event,
    price: price,
    effectiveQuantity: effectiveQuantity,
    totalFreeProdCount: totalFreeProdCount
  });
  
  if (filteredObjects.length > 0) {
    // First, collect ALL GWP variant IDs from ALL rules so we can remove them if needed
    const allGwpVariantIds = new Set();
    filteredObjects.forEach(rule => {
      const variants = getMarketGwpVariants(rule);
      if (variants && Array.isArray(variants)) {
        variants.forEach(variantUrl => {
          const variantId = variantUrl.split('/').pop();
          if (variantId) allGwpVariantIds.add(variantId);
        });
      }
    });
    
    // Initially set all GWP products to 0 (remove them)
    allGwpVariantIds.forEach(gwpId => {
      cartProductUpdated[gwpId] = 0;
    });
    
    const applicableRule = filteredObjects
      .filter((rule) => {
        var rule_trigger_price = getMarketTriggerPrice(rule);

        console.log("rule_trigger_price", rule_trigger_price, "activeMarket", window.activeMarket);
        if (rule.triggered_quantity !== undefined) {
          return adjustedCartTotal >= rule.triggered_quantity;
        }
        if (rule_trigger_price !== undefined) {
          return adjustedCartTotalPrice >= rule_trigger_price * 100;
        }
        return false;
      })
      .sort((a, b) => {
        var a_trigger_price = getMarketTriggerPrice(a);
        var b_trigger_price = getMarketTriggerPrice(b);
        // Sort based on the available field (`triggered_quantity` or `price`)
        if (
          a.triggered_quantity !== undefined &&
          b.triggered_quantity !== undefined
        ) {
          return b.triggered_quantity - a.triggered_quantity; // Higher triggered_quantity first
        }
        if (a_trigger_price !== undefined && b_trigger_price !== undefined) {
          return b_trigger_price - a_trigger_price; // Higher price first
        }
        return 0; // Default if incomparable
      })[0]; // Get the rule with the highest value

    if (applicableRule) {
      // Only add freebies if the cart threshold is actually met
      let thresholdMet = false;
      var rule_trigger_price = getMarketTriggerPrice(applicableRule);
      
      // Check if threshold is actually met
      if (applicableRule.triggered_quantity !== undefined) {
        thresholdMet = adjustedCartTotal >= applicableRule.triggered_quantity;
      } else if (rule_trigger_price !== undefined) {
        thresholdMet = adjustedCartTotalPrice >= rule_trigger_price * 100;
      }
      
      console.log("Threshold check:", {
        thresholdMet,
        adjustedCartTotalPrice,
        rule_trigger_price: rule_trigger_price * 100,
        adjustedCartTotal,
        triggered_quantity: applicableRule.triggered_quantity,
        activeMarket: window.activeMarket
      });
      
      // Only add freebies if threshold is met
      const marketGwpVariants = getMarketGwpVariants(applicableRule);
      if (thresholdMet && marketGwpVariants?.length > 0) {
        const extractedIds = marketGwpVariants.map((variant) =>
          variant.split("/").pop()
        );

        extractedIds.forEach(function (value) {
          cartProductUpdated[value] = 1;
        });
      }
      // If threshold not met, freebies remain at 0 (already set above)
      
      if (
        applicableRule?.cart_confetti &&
        event &&
        event != "REMOVED_FROM_CART" &&
        thresholdMet
      ) {
        cartConfetti = applicableRule.cart_confetti;
      }
    }
    // If no applicable rule, freebies remain at 0 (already set above)
  } else {
    // No rules available - remove any existing freebies
    cart.items.forEach(function (value) {
      if (value.handle && value.handle.toLowerCase().includes('gwp')) {
        cartProductUpdated[value.id.toString()] = 0; // Remove freebie
      }
    });
  }

  //Update Cart based on addition or subtraction
  if (event) {
    if (event === "ADD_ALL_TO_CART") {
      // Handle the case where variantId is an array for "ADD_ALL_TO_CART"
      variantId.forEach((id) => {
        const productKey = id.toString();
        const currentQuantity = cartProductUpdated[productKey] || 0;
        cartProductUpdated[productKey] = currentQuantity + 1;
      });
    } else {
      // Handle individual variantId for "ADD_TO_CART" and "REMOVED_FROM_CART"
      const productKey = variantId.toString();
      const currentQuantity = cartProductUpdated[productKey] || 0;

      if (event === "ADD_TO_CART") {
        if (!window.QSVL?.isOverlayOpen) {
          // Only increment if not from overlay (i.e., native add to cart)

          cartProductUpdated[productKey] = currentQuantity + quantity;
        } else {
          // If triggered by app, just retain current quantity (or skip updating it)
          Optional: cartProductUpdated[productKey] = currentQuantity;
          if (!isQuin) {
            cartProductUpdated[productKey] = currentQuantity + quantity;
          }
        }
      } else if (event === "REMOVED_FROM_CART") {
        cartProductUpdated[productKey] = Math.max(
          currentQuantity - quantity,
          0
        );
      }
    }
  }

  const final_jsonObject = {};

  final_jsonObject["updates"] = cartProductUpdated;

  const section_div_id = document.querySelector(
    ".shopify-section.shopify-section-header"
  )?.id;
  const sectionId = section_div_id.replace("shopify-section-", "");
  // const sectionDiv = document.querySelector(".shopify-section.shopify-section-header");
  // const sectionId = sectionDiv.id.replace("shopify-section-", ""); // Extract section ID
  console.log("Section ID:", sectionId);

  getCurrentTime("update call start time");

  // window.QSVL.isOverlayOpen
  console.log("window.QSVL", window.QSVL);
  //API Call for /update.js
  if (Object.keys(cartProductUpdated).length !== 0) {
    /*
      $.ajax sent `data: {updates: {...}}` with jQuery's default content type,
      i.e. form-urlencoded as updates%5B<id>%5D=<qty>. That exact encoding is
      rebuilt here rather than switching to a JSON body, so the request Shopify
      receives is unchanged.
    */
    var updateBody = new URLSearchParams();
    Object.keys(final_jsonObject["updates"]).forEach(function (variantId) {
      updateBody.append("updates[" + variantId + "]", final_jsonObject["updates"][variantId]);
    });

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
      body: updateBody,
    })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(function (cartJson) {
        let cartData = cartJson;
        let cart_count = cartJson.item_count;
        user_cart = cartJson;

        getCurrentTime("Cart data call start time");
        return fetch(window.location.pathname + "?sections=" + sectionId)
          .then((res) => res.json())
          .then((data) => {
            console.log(data, "data sectionId", cart_count);
            const updated_cart = data[sectionId];

            const cartDrawerEl = document.getElementById("cart-drawer");
            const parsedSection = parseSectionHtml(updated_cart);
            const drawerTemplate = parsedSection.querySelector("#cart-drawer template");
            const drawerSource = drawerTemplate || parsedSection.querySelector("#cart-drawer");
            if (cartDrawerEl && drawerSource) {
              setHtmlAndRunScripts(cartDrawerEl, drawerSource.innerHTML);
            }

            // The drawer markup above is now fresh, so any free-sample line that no
            // longer qualifies (e.g. the paid product it required was just removed)
            // can be reconciled off the cart using the just-rendered entitlement data.
            if (typeof window.reconcileSampleEntitlements === "function") {
              window.reconcileSampleEntitlements();
            }

            /*
              Fill the upsells straight away. The new drawer markup arrives holding the
              skeletons, the product JSON is already in flight from the click, and
              `cartJson` saves a /cart.js round trip - so the shopper goes from skeleton
              to the relevant products with nothing in between. loadUpsellProducts()
              builds the holder itself when the markup didn't include one.
            */
            const cartDrawer = document.querySelector("#cart-drawer");
            if (!cartDrawer || !document.contains(cartDrawer)) {
              console.warn("Cart drawer not found, skipping upsell load");
            } else {
              loadUpsellProducts(cartJson);
            }

            document.querySelectorAll('.cart__toggle').forEach(function (btn) {
              btn.classList.toggle('cart__toggle--has-items', cart_count > 0);
            });
            // Keeps the PDP floating cart's count in sync (assets/pdp-floating-cart.js).
            document.dispatchEvent(new CustomEvent("aiza:cart:updated", { detail: { itemCount: cart_count } }));

            if (event && !window.QSVL?.isOverlayOpen) {
              openCartDrawer();
              // Main PDP Add to Cart: also show the "Added to cart" toast, inside the
              // drawer that just opened (assets/pdp-floating-cart.js).
              if (pdpCartToastPending && event === "ADD_TO_CART") {
                document.dispatchEvent(new CustomEvent("aiza:cart:toast", { detail: { inDrawer: true } }));
              }
              getCurrentTime("All Complete time");
            }
            pdpCartToastPending = false;

            console.log("cartDatass",cartData)

            try {
              let originalSubtotal = 0;
              originalSubtotal = cartData.items.reduce((sum, item) => {
                return sum + item.original_price * item.quantity;
              }, 0);

              const subtotalValue = parseFloat(cartData.total_price);

              const subtotalContainer = document.querySelector(".cd_checkout_subtotal");
              if (subtotalContainer) {
                if (subtotalValue === originalSubtotal) {
                  subtotalContainer.style.display = "none";
                } else {
                  subtotalContainer.style.display = "";
                }
              }
            } catch (err) {
              console.error("Error processing subtotal vs total:", err);
            }

            if (cart_count === 0 && !window.autoDiscount?.hasPendingCode()) {
              console.log("Cart is empty – removing all coupons");
              removeCoupon("");
            }
          });
      })
      .catch(function (error) {
        // Covers what $.ajax split across its `error` callback and the
        // status == "error" branch of `complete`.
        console.error("Error updating the cart:", error);
        pdpCartToastPending = false;
        document.querySelectorAll('button[type="submit"]').forEach(function (button) {
          button.removeAttribute("aria-busy");
        });
      });
  } else {
    pdpCartToastPending = false;
  }
}


scheduleTask(function () {
function delegateClick(selector, handler) {
  document.addEventListener("click", function (e) {
    if (!(e.target instanceof Element)) return;
    var match = e.target.closest(selector);
    if (match) handler.call(match, e);
  });
}

function formInputValue(button, name) {
  var form = button.closest("form");
  var input = form ? form.querySelector('input[name="' + name + '"]') : null;
  return input ? input.value : undefined;
}

function textOf(parent, selector) {
  var el = parent.querySelector(selector);
  return el ? el.textContent : '';
}

function htmlOf(parent, selector) {
  var el = parent.querySelector(selector);
  return el ? el.innerHTML : '';
}

/*
  PLP card - add to cart.

  Deliberately bound to the .product__submit__add selector only. The original
  read:

    $(document).on("click", "<add-selector>", "<upsell-selector>", handler)

  and jQuery's signature is .on(events, selector, data, handler) - so the second
  string was passed as `data`, never as a selector, and this handler has only
  ever fired for .product__submit__add. PLP upsell buttons are already covered by
  the document-wide "button.product__submit__add, button.product-upsell__btn"
  handler above; matching them here too would add to the cart twice per click.
*/
delegateClick(
  ".product-grid-item .product-card__form button.product__submit__add",
  function (e) {
    e.preventDefault();
    var gridItem = this.closest(".product-grid-item");
    var product_handle = gridItem ? gridItem.getAttribute('data-product-handle') : undefined;
    var upsell_products = gridItem ? gridItem.getAttribute('upsell-products') : undefined;
    var product_id = formInputValue(this, "id");
    var quantityValue = formInputValue(this, "quantity");
    var product_qty = quantityValue !== undefined ? parseInt(quantityValue) : 1;
    var product_price = formInputValue(this, "price");
    setCartUpsell(upsell_products);
    document.querySelectorAll(".shopify-section-header").forEach(function (header) {
      header.classList.add("z-index-high");
    });
    cartGiftUpdate(product_id, product_price, product_qty, product_handle, "ADD_TO_CART");
  }
);

// Routine & Sets - add to cart
delegateClick(".routine-add-btn", function (e) {
  e.preventDefault();
  var btn = this;
  var product_id = btn.getAttribute('data-product-id');
  var product_handle = btn.getAttribute('data-product-handle');
  var product_price = btn.getAttribute('data-price');
  var upsell_products = btn.getAttribute('upsell-products') || '';
  var originalPriceText = htmlOf(btn, '.routine-add-price');
  var originalButtonText = textOf(btn, '.routine-add-text') || 'Add For';
  var originalComparePriceText = htmlOf(btn, '.product__price--compare');
  // Store upsell products
  setCartUpsell(upsell_products);

  // Disable button and show loading state
  btn.disabled = true;
  btn.innerHTML = '<span>Adding...</span>';

  // Call cartGiftUpdate
  cartGiftUpdate(product_id, product_price, 1, product_handle, "ADD_TO_CART");

  // Reset button after delay
  setTimeout(function() {
    btn.disabled = false;
    btn.innerHTML = '<span class="routine-add-text">' + originalButtonText + '</span> <span class="routine-add-price">' + originalPriceText + '</span> <span data-compare-price class="product__price--compare">' + originalComparePriceText + '</span>';
  }, 2000);
});
});

/*
  Product JSON for the upsell cards, fetched once per handle and reused for the rest
  of the page's life. setCartUpsell() starts these fetches at add-to-cart click time
  so they run alongside /cart/update.js and the ?sections= reload instead of only
  starting once the new drawer HTML has landed. The cards' "already in cart" filter
  still uses fresh cart data on every render, so caching the product JSON can't leave
  a product in the list after it's been added.
*/
const upsellProductCache = new Map();

function fetchUpsellProduct(handle) {
  if (!upsellProductCache.has(handle)) {
    upsellProductCache.set(
      handle,
      fetch(`/products/${handle}.js`)
        .then(res => (res.ok ? res.json() : null))
        .catch(() => null)
    );
  }
  return upsellProductCache.get(handle);
}

function getUpsellHandles() {
  const stored = localStorage.getItem("cartUpsell");
  let handles = stored ? stored.split(",").map(h => h.trim()).filter(Boolean) : [];

  if (handles.length == 0) {
    const isLocale = localStorage.getItem("ls-locale") || "en";
    if (isLocale === "ar") {
      handles = [
        "ديت-سيتر-سيروم-تعزيز-الحواجب-والرموش",
        "سكر-رش-علاج-للشفاه-عالي-اللمعان",
        "نكتار-نوار-ماسك-الشعر-نيوتريبلنيش"
      ];
    } else {
      handles = [
        "date-setter-brow-and-lash-boosting-serum",
        "sukkar-rush-high-shine-lip-treatment",
        "nectar-noir-nutri-plenish-hair-mask"
      ];
    }
  }

  return handles;
}

// Record which upsells the next drawer render should show, and start fetching them now.
function setCartUpsell(value) {
  localStorage.setItem("cartUpsell", value);
  getUpsellHandles().forEach(fetchUpsellProduct);
}

function getProductMetafields() {
  const el = document.getElementById("product-metafields");
  if (!el) return {};
  try {
    return JSON.parse(el.textContent);
  } catch (err) {
    console.warn("Could not parse product metafields", err);
    return {};
  }
}

function renderUpsellSkeletons(count = 3) {
  const wrapper = document.querySelector("[data-dynamic-upsell]");
  if (!wrapper) return;
  wrapper.innerHTML = "";
  for (let i = 0; i < count; i++) {
    const skeleton = `
      <div class="product-upsell__holder product-upsell__holder--cart skeleton">
        <div class="product-upsell">
          <!-- Image placeholder -->
          <div class="product-upsell__image skeleton-box"></div>

          <div class="product-upsell__content">
            <div class="product-upsell__row">
              <!-- Title placeholder -->
              <div class="skeleton-line skeleton-line--title"></div>
              <!-- Description placeholder -->
              <div class="skeleton-line skeleton-line--desc"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    wrapper.insertAdjacentHTML("beforeend", skeleton);
  }
}

function clearSkeletons() {
  const wrapper = document.querySelector("[data-dynamic-upsell]");
  if (wrapper) wrapper.innerHTML = "";
}

// Helper function to detect Arabic locale (matches PDP gallery logic)
function getIsArabicLocale() {
  if (document.body.classList.contains('lang-ar')) return true;
  if (document.body.classList.contains('lang-en')) return false;
  return (localStorage.getItem('ls-locale') || 'en').toLowerCase().includes('ar');
}

// Helper function to get English and Arabic images
function getProductImages(product) {
  const isArabic = getIsArabicLocale();
  
  let englishImage = null;
  let arabicImage = null;
  
  // Check product media for images with 'arabic' in alt text
  if (product.media && Array.isArray(product.media)) {
    product.media.forEach(media => {
      if (media.alt && /arabic|عربي/.test(media.alt.toLowerCase())) {
        if (!arabicImage) arabicImage = media.src || media.preview_image?.src;
      } else {
        if (!englishImage) englishImage = media.src || media.preview_image?.src;
      }
    });
  }
  
  // Fallback to featured_image
  if (!englishImage) englishImage = product.featured_image;
  if (!arabicImage) arabicImage = product.featured_image;
  
  return {
    english: englishImage,
    arabic: arabicImage,
    isArabic: isArabic
  };
}

/*
  Bumped by every loadUpsellProducts() call. Several paths can ask for a render at
  once - the add-to-cart handler, the quinn:atc listener, the drawer-open observer -
  and the one that asked LAST is the one holding the current cart state, so it has to
  be the one that paints. Dropping the later call instead (what a plain "already
  loading" flag does) leaves the previous product's cards on screen.
*/
let upsellLoadToken = 0;

// Only read by the drawer-open fallback below, so it knows whether anyone is already
// on it. Never used to drop a load - see the note above.
let upsellLoadInFlight = false;

// Returns "" for a handle that didn't resolve or a product already in the cart.
function buildUpsellCard(product, cartVariantIds, metafields) {
  if (!product) return "";
  if (product.variants.some(v => cartVariantIds.includes(v.id))) return "";

  const money = amount =>
    CURRENCY_SYMBOL_HTML[Shopify.currency.active] ? formatMoney(amount, Shopify.currency.active) : new Intl.NumberFormat(Shopify.locale, {
      style: "currency",
      currency: Shopify.currency.active,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount / 100);

  const price = money(product.price);
  const formattedCompare = product.compare_at_price ? money(product.compare_at_price) : "";
  const shortDescription = metafields[product.handle]?.short_description || "";
  const upsellProds = metafields[product.handle]?.upsell_products || [];
  const images = getProductImages(product);

  return `
    <div class="product-upsell__holder product-upsell__holder--cart" data-product-card="${product.id}">
      <div class="product-upsell">

        <!-- ENGLISH IMAGE WRAPPER -->
        <a class="product-upsell__image upsell-image-lang-wrapper english-image"
           data-lang-image="en"
           href="${product.url}">
          <img ${images.isArabic ? "data-locale-src" : "src"}="${images.english}" alt="${product.title}" loading="lazy" decoding="async">
        </a>

        <!-- ARABIC IMAGE WRAPPER -->
        <a class="product-upsell__image upsell-image-lang-wrapper arabic-image"
           data-lang-image="ar"
           href="${product.url}"
           style="display: none;">
          <img ${images.isArabic ? "src" : "data-locale-src"}="${images.arabic}" alt="${product.title}" loading="lazy" decoding="async">
        </a>

        <div class="product-upsell__content">
          <div class="product-upsell__row">
            <p class="product-upsell__title h3">
              <a href="${product.url}">${product.title}</a>
            </p>
            <span class="prod-upsell-functional-name">${shortDescription}</span>
          </div>
        </div>

        <div>
          <form method="post" action="/cart/add" class="product-card__form">
            <input type="hidden" name="id" value="${product.variants[0].id}">
            <input type="hidden" name="price" value="${product.price}">
            <button type="submit"
                    class="product-upsell__btn btn btn--solid-border btn--medium btn--secondary"
                    data-add-to-cart
                    data-upsell-btn
                    data-product-title="${product.title}"
                    data-handle="${product.handle}"
                    upsell-products="${upsellProds}">
              <span class="product-upsell__btn-text">Shop <br>${price} <br><del>${formattedCompare}</del></span>
            </button>
          </form>
        </div>
      </div>
    </div>
  `;
}

/*
  Renders the upsell cards into the drawer. Pass `cartData` (e.g. the /cart/update.js
  response) to skip the extra /cart.js round trip.
*/
async function loadUpsellProducts(cartData) {
  const token = ++upsellLoadToken;
  upsellLoadInFlight = true;

  // Only the newest load owns the flag, so a superseded one can't clear it early.
  const done = () => {
    if (token === upsellLoadToken) upsellLoadInFlight = false;
  };

  let wrapper = document.querySelector("[data-dynamic-upsell]");

  // Create wrapper if it doesn't exist (e.g., when cart drawer HTML is replaced)
  if (!wrapper) {
    const cartUpsellHolder = document.querySelector("#cartUpsellHolder");
    if (cartUpsellHolder) {
      // Check if there's already content but no wrapper
      const existingContent = cartUpsellHolder.innerHTML.trim();
      if (existingContent && !existingContent.includes('data-dynamic-upsell')) {
        // Clear existing content and create wrapper
        cartUpsellHolder.innerHTML = '';
      }
      
      // Create the heading if it doesn't exist
      if (!cartUpsellHolder.querySelector('.cd-might-like')) {
        const headingDiv = document.createElement('div');
        headingDiv.className = 'cd-might-like';
        headingDiv.innerHTML = '<h3>Complete your Routine</h3>';
        cartUpsellHolder.appendChild(headingDiv);
      }
      
      // Create the wrapper structure
      const wrapperDiv = document.createElement('div');
      wrapperDiv.className = 'upsell-wrapper';
      wrapperDiv.setAttribute('data-dynamic-upsell', '');
      cartUpsellHolder.appendChild(wrapperDiv);
      wrapper = wrapperDiv;
    } else {
      // If cartUpsellHolder doesn't exist, we can't proceed
      done();
      return;
    }
  }

  // Verify wrapper still exists before proceeding
  if (!wrapper || !document.contains(wrapper)) {
    console.warn("Upsell wrapper not found or removed from DOM");
    done();
    return;
  }

  const handles = getUpsellHandles();

  /*
    The drawer markup ships with these skeletons already in it, so only paint them
    when the wrapper came from somewhere that didn't - the one built above, or a
    render that has already swapped real cards in.
  */
  if (!wrapper.querySelector(".skeleton")) {
    renderUpsellSkeletons(handles.length || 3);
  }

  const metafields = getProductMetafields();

  try {
    /*
      Cart state and product JSON go out together instead of the products waiting on
      /cart.js. The product fetches normally resolve straight from the cache primed at
      add-to-cart click time.
    */
    const [cart, products] = await Promise.all([
      cartData ? Promise.resolve(cartData) : fetch("/cart.js").then(res => res.json()),
      Promise.all(handles.map(fetchUpsellProduct))
    ]);

    const cartVariantIds = cart.items.map(item => item.variant_id);
    const productsHtml = products.map(product =>
      buildUpsellCard(product, cartVariantIds, metafields)
    );

    // A newer load started while this one was fetching; it owns the wrapper now.
    if (token !== upsellLoadToken) return;

    // Verify wrapper still exists before updating
    wrapper = document.querySelector("[data-dynamic-upsell]");
    if (!wrapper || !document.contains(wrapper)) {
      console.warn("Upsell wrapper removed during load, aborting update");
      return;
    }

    const combined = productsHtml.filter(Boolean).join("");
    const upsellHolder = document.querySelector("#cartUpsellHolder");

    if (!combined) {
      // hide upsell holder if no products left
      if (upsellHolder) upsellHolder.style.display = "none";
      wrapper.innerHTML = "";
      return;
    }

    // Undo a hide left by an earlier render that had nothing to show.
    if (upsellHolder) upsellHolder.style.removeProperty("display");

    // Skeletons and cards swap in the same paint - no fade-out wait in between.
    wrapper.innerHTML = combined;
  } catch (error) {
    console.error("Error loading upsell products:", error);
    if (token === upsellLoadToken) clearSkeletons();
  } finally {
    done();
  }
}

/*
  The drawer markup now ships with skeletons instead of cards, so every path that opens
  it has to end up calling the loader - including ones that don't go through the
  handlers above, like the theme's own [data-cart-drawer-toggle]. Watching the open
  class covers all of them. The skeleton check means the normal flow, where the cards
  are already in place, costs nothing.
  custom.js is deferred, so the DOM is ready when this runs.
*/
const cartDrawerForUpsells = document.getElementById("cart-drawer");
if (cartDrawerForUpsells) {
  new MutationObserver(() => {
    if (!cartDrawerForUpsells.classList.contains("is-open")) return;

    if (upsellLoadInFlight) return;

    const wrapper = cartDrawerForUpsells.querySelector("[data-dynamic-upsell]");
    if (wrapper && wrapper.querySelector(".skeleton")) {
      loadUpsellProducts();
    }
  }).observe(cartDrawerForUpsells, { attributes: true, attributeFilter: ["class"] });
}

/*
  Warm the product JSON on the first hint the shopper is heading for the cart, so a
  drawer opened without a preceding add-to-cart has its cards ready too. Cached per
  handle, so the repeat events are free.
*/
["pointerover", "touchstart", "focusin"].forEach(type => {
  document.addEventListener(
    type,
    e => {
      if (!(e.target instanceof Element)) return;
      const toggle = e.target.closest(
        "a.dev_cart_icon_click, a.mobile-menu__button.cart__toggle, [data-cart-drawer-toggle]"
      );
      if (toggle) getUpsellHandles().forEach(fetchUpsellProduct);
    },
    { passive: true, capture: true }
  );
});

// Toggle upsell image visibility when language changes
document.addEventListener('language:change', (e) => {
  const newLang = (e.detail?.lang || '').toLowerCase();
  const showArabic = newLang ? newLang.includes('ar') : getIsArabicLocale();
  const wrapper = document.querySelector('[data-dynamic-upsell]');
  if (!wrapper) return;
  wrapper.querySelectorAll('.english-image').forEach(el => el.style.display = showArabic ? 'none' : '');
  wrapper.querySelectorAll('.arabic-image').forEach(el => el.style.display = showArabic ? '' : 'none');
});

document.addEventListener("click", (e) => {
  const minusBtn = e.target.closest(".quantity__btn--decrease");
  const plusBtn = e.target.closest(".quantity__btn--increase");

  if (!minusBtn && !plusBtn) return;

  const form = e.target.closest(".product-card__form");
  if (!form) return;

  const input = form.querySelector(".quantity__selector");
  if (!input) return;

  const continueSelling = form.dataset.continueSelling === "true";
  const maxQty = parseInt(input.getAttribute("max"), 10) || 9999;
  const minQty = parseInt(input.getAttribute("min"), 10) || 1;

  e.preventDefault();
  e.stopPropagation();

  let value = parseInt(input.value, 10) || 1;

  // Handle decrease
  if (minusBtn && value > minQty) {
    value--;
  }

  // Handle increase (limit to maxQty)
  if (plusBtn && value < maxQty) {
    value++;
  }

  // Update the input value
  input.value = value;

  // Disable/enable buttons based on limits
  const minusButton = form.querySelector(".quantity__btn--decrease");
  const plusButton = form.querySelector(".quantity__btn--increase");

  if (minusButton) minusButton.disabled = value <= minQty;
  if (plusButton) plusButton.disabled = !continueSelling && value >= maxQty;

  // Trigger change event for other listeners
  input.dispatchEvent(new Event("change", { bubbles: true }));
});


//cart couponss
async function refreshCartDrawerSection() {
  const sectionDiv = document.querySelector('.shopify-section.shopify-section-header');
  if (!sectionDiv) return;
  const sectionId = sectionDiv.id.replace('shopify-section-', '');

  const res = await fetch(window.location.pathname + '?sections=' + sectionId);
  const data = await res.json();
  const updatedCart = data[sectionId];
  if (!updatedCart) return;

  const cartDrawerEl = document.getElementById('cart-drawer');
  const wasOpen = cartDrawerEl ? cartDrawerEl.classList.contains('is-open') : false;

  const parsedSection = parseSectionHtml(updatedCart);
  const drawerTemplate = parsedSection.querySelector('#cart-drawer template');
  const drawerSource = drawerTemplate || parsedSection.querySelector('#cart-drawer');
  if (cartDrawerEl && drawerSource) {
    setHtmlAndRunScripts(cartDrawerEl, drawerSource.innerHTML);
  }

  if (wasOpen) {
    openCartDrawer();
  }

  if (typeof loadUpsellProducts === 'function') {
    loadUpsellProducts();
  }
}

async function applyDiscountCode() {
  const code = document.getElementById('cart-discount-code')?.value.trim();
  const codeInput = document.getElementById('cart-discount-code');
  let messageEl = document.getElementById('discount-message');
  const discountBtn = document.getElementById('applyDiscountBtn');

  if (codeInput) {
    codeInput.value = '';
  }

  // Add loader
  discountBtn.classList.add('loading');
  discountBtn.disabled = true;

  if (!code) {
    messageEl.textContent = "Please enter a code";
    showTempMessage(messageEl);
    discountBtn.classList.remove('loading');
    discountBtn.disabled = false;
    return;
  }

  try {
    // Get current cart
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    // Apply code
    const applyResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });

    if (!applyResponse.ok) {
      const errorText = await applyResponse.text();
      throw new Error(errorText || 'Failed to apply discount');
    }

    // Updated cart
    const updatedCartResponse = await fetch('/cart.js');
    const updatedCartData = await updatedCartResponse.json();

    const normalizedCode = code.toLowerCase();
    const isApplied =
      updatedCartData.discount_codes?.some(
        dc => dc.code.toLowerCase() === normalizedCode && dc.applicable
      );

    if (isApplied) {
      const savings = cartData.total_price - updatedCartData.total_price;
      const messageText = savings > 0
        ? `Coupon applied! You saved ${formatMoney(savings, updatedCartData.currency)}`
        : "Coupon already applied!";

      // Re-render the cart drawer so freebie text, compare-at-price discount,
      // subtotal, total, and applied-coupons list all reflect the new cart state.
      // This avoids the JS-side recalculation that ignored compare-at-price savings.
      await refreshCartDrawerSection();
      if (typeof window.reconcileSampleEntitlements === "function") {
        window.reconcileSampleEntitlements();
      }

      messageEl = document.getElementById('discount-message');
      if (messageEl) {
        messageEl.innerHTML = messageText;
        showTempMessage(messageEl);
      }
    } else {
      throw new Error('Invalid or ineligible code');
    }
  } catch (error) {
    console.error('Discount application error:', error);
    messageEl = document.getElementById('discount-message');
    if (messageEl) {
      messageEl.textContent = error.message || 'An error occurred while applying the discount.';
      showTempMessage(messageEl);
    }
  } finally {
    const btn = document.getElementById('applyDiscountBtn');
    if (btn) {
      btn.classList.remove('loading');
      btn.disabled = false;
    }
  }
}

// Helper: show message then auto-hide
function showTempMessage(el) {
  el.classList.remove('hide'); // reset if hidden
  clearTimeout(el._timeout); // cancel old timers
  el._timeout = setTimeout(() => {
    el.classList.add('hide');
  }, 5000);
}


// Remove coupon
async function removeCoupon(_code) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: "" }) // Shopify only supports 1 discount
    });
    if (!response.ok) throw new Error("Failed to remove discount");

    // Re-render the cart drawer so the Liquid recomputes total_discount,
    // subtotal, freebie text and applied-coupons list against the fresh cart.
    await refreshCartDrawerSection();
    if (typeof window.reconcileSampleEntitlements === "function") {
      window.reconcileSampleEntitlements();
    }
  } catch (err) {
    console.error("Error removing coupon:", err);
  }
}



// Render applied coupons
function renderAppliedCoupons(coupons) {
  console.log("renderAppliedCoupons",coupons)
  const container = document.getElementById('applied-coupons');
  container.innerHTML = "";

  if (coupons && coupons.length > 0) {
    coupons.forEach(coupon => {
      const div = document.createElement("div");
      div.className = "applied-coupon";
      div.innerHTML = `
        <span>${coupon.code}</span>
        <button type="button" onclick="removeCoupon('${coupon.code}')">✕</button>
      `;
      container.appendChild(div);
    });
    container.style.visibility = "visible";
    container.style.display = "flex";
  } else {
    container.style.visibility = "hidden";
    container.style.display = "none";
  }
}

// Format money
const CURRENCY_SYMBOL_HTML = {
  AED: '<span class="currency-symbol currency-symbol--aed" role="img" aria-label="AED"></span>&nbsp;',
  SAR: '<span class="currency-symbol currency-symbol--sar" role="img" aria-label="SAR"></span>&nbsp;'
};

function formatMoney(cents, currency) {
  if (CURRENCY_SYMBOL_HTML[currency]) {
    return CURRENCY_SYMBOL_HTML[currency] + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  });
}

function updateSubtotals(cartData) {
  console.log("updateSubtotals",cartData)
  const subtotalEl = document.querySelector('.cart__buttons [data-cart-total-price]');
  if (subtotalEl) {
    subtotalEl.innerHTML = formatMoney(cartData.total_price, cartData.currency);
  }
  console.log("total", cartData.total_price);

  const originalSubtotalEl = document.querySelector('.cd_checkout_subtotal [data-cart-subtotal-price]');
  let originalSubtotal = 0;
  if (originalSubtotalEl) {
    originalSubtotal = cartData.items.reduce((sum, item) => {
      return sum + item.original_price * item.quantity;
    }, 0);
    originalSubtotalEl.innerHTML = formatMoney(originalSubtotal, cartData.currency);
  }
  console.log("subtotal", originalSubtotal);

    const subtotalValue = parseFloat(cartData.total_price);

    const subtotalContainer = document.querySelector('.cd_checkout_subtotal');
    if (subtotalContainer) {
      if (subtotalValue === originalSubtotal) {
        subtotalContainer.style.display = 'none';
      } else {
        subtotalContainer.style.display = '';
      }
    }
}

document.addEventListener("DOMContentLoaded", async () => {
  try {
    // wait 300ms before fetching cart
    setTimeout(async () => {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      console.log("cartData", cartData);
      const applicableCoupons = cartData.discount_codes.filter(dc => dc.applicable);
      console.log("applicableCoupons",applicableCoupons)
      renderAppliedCoupons(applicableCoupons);
      loadUpsellProducts();
      let originalSubtotal = 0;
        originalSubtotal = cartData.items.reduce((sum, item) => {
          return sum + item.original_price * item.quantity;
        }, 0);

        const subtotalValue = parseFloat(cartData.total_price);

        console.log("cartsubtotal", originalSubtotal,subtotalValue);
    
        const subtotalContainer = document.querySelector('.cd_checkout_subtotal');
        if (subtotalContainer) {
          if (subtotalValue === originalSubtotal) {
            subtotalContainer.style.display = 'none';
          } else {
            subtotalContainer.style.display = '';
          }
        }
    }, 3000);
  } catch (err) {
    console.error("Error loading applied coupons:", err);
  }
});


document.addEventListener("click", () => {
    const qtyInputs = document.querySelectorAll(".quantity__input, .cart__item__quantity-field, .quantity__selector");

    if (!qtyInputs.length) return; // stop if no inputs

    qtyInputs.forEach((input) => {
      // Avoid attaching listeners multiple times
      if (input.dataset.listenersAttached) return;
      input.dataset.listenersAttached = "true";
      input.addEventListener("keydown", (e) => e.preventDefault());

      input.addEventListener("paste", (e) => e.preventDefault());

      input.addEventListener("input", () => {
        input.value = input.value.replace(/\D/g, "");
      });
    });
});

document.addEventListener("click", function (e) {
  const header = document.querySelector('.shopify-section-header');
  const filtersEl = document.querySelector('[data-collection-filters]');
  const toggleBtns = document.querySelectorAll('.collection__filters__toggle');

  if (!header || !filtersEl || toggleBtns.length === 0) return;

  // Check if the click is on any toggle button
  const clickedOnToggle = Array.from(toggleBtns).some(btn => btn.contains(e.target));

  // If click is outside the filter area and not on any toggle button
  if (!filtersEl.contains(e.target) && !clickedOnToggle) {
    const wasOpen = filtersEl.classList.contains("collection__filters--visible");

    header.classList.remove("z-index-low");
    filtersEl.classList.remove("collection__filters--visible");

    // Release the lock openFilter() took. Only when the drawer was actually open — this handler
    // runs on every click on the page, and an unconditional unlock would drop the lock held by
    // another drawer (cart, quick view).
    if (wasOpen) {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.disclosure__item a').forEach(link => {
    link.addEventListener("click", function () {
      localStorage.setItem("cartUpsell", "");
    });
  });
});



// PLP Layout Switcher
// custom.js is loaded with defer, so the DOM is ready when this runs.
// DOMContentLoaded fallback is kept as a safety net in case defer is ever removed.
(function () {
  var LAYOUT_KEY = 'plp-layout';

  function syncLayout(isNarrow) {
    var container = document.querySelector('[data-layout-switcher]');
    if (container) container.classList.toggle('layout--narrow', isNarrow);
    document.documentElement.classList.toggle('plp-layout-narrow', isNarrow);
    var btnWide = document.querySelector('[data-layout-wide]');
    var btnNarrow = document.querySelector('[data-layout-narrow]');
    if (btnWide) btnWide.classList.toggle('is-active', !isNarrow);
    if (btnNarrow) btnNarrow.classList.toggle('is-active', isNarrow);
  }

  function setLayout(isNarrow) {
    localStorage.setItem(LAYOUT_KEY, isNarrow ? 'narrow' : 'wide');
    syncLayout(isNarrow);
  }

  // Event delegation — survives AJAX replacement of any ancestor
  document.addEventListener('click', function (e) {
    var wide = e.target.closest && e.target.closest('[data-layout-wide]');
    if (wide) { setLayout(false); return; }
    var narrow = e.target.closest && e.target.closest('[data-layout-narrow]');
    if (narrow) { setLayout(true); }
  });

  // Re-apply saved state whenever filters/sort re-render the grid
  var observer = new MutationObserver(function () {
    syncLayout(localStorage.getItem(LAYOUT_KEY) === 'narrow');
  });
  function observeGrid() {
    var container = document.querySelector('[data-layout-switcher]');
    if (container) observer.observe(container, { childList: true, subtree: false });
  }

  function init() {
    syncLayout(localStorage.getItem(LAYOUT_KEY) === 'narrow');
    observeGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

// PLP Mobile Layout Switcher
// Independent from the desktop switcher — uses its own localStorage key and CSS class.
// custom.js is loaded with defer, so the DOM is ready when this runs.
// DOMContentLoaded fallback is kept as a safety net in case defer is ever removed.
(function () {
  var MOBILE_LAYOUT_KEY = 'plp-layout-mobile-v2';
  var grid, btnSingle, btnDouble;

  function setMobileLayout(isDouble) {
    if (!grid || !btnSingle || !btnDouble) return;
    grid.classList.toggle('mobile-layout--double', isDouble);
    document.documentElement.classList.toggle('plp-mobile-layout-double', isDouble);
    btnSingle.classList.toggle('is-active', !isDouble);
    btnDouble.classList.toggle('is-active', isDouble);
    localStorage.setItem(MOBILE_LAYOUT_KEY, isDouble ? 'double' : 'single');
  }

  function bindMobileSwitcher() {
    grid = document.querySelector('[data-layout-switcher]');
    btnSingle = document.querySelector('[data-mobile-layout-single]');
    btnDouble = document.querySelector('[data-mobile-layout-double]');
    if (btnSingle) btnSingle.addEventListener('click', function () { setMobileLayout(false); });
    if (btnDouble) btnDouble.addEventListener('click', function () { setMobileLayout(true); });
    // Restore saved state after DOM refs are populated — always call to set correct button state.
    // Default to double (4-tile) view when no preference is stored; only honor an explicit 'single' choice.
    setMobileLayout(localStorage.getItem(MOBILE_LAYOUT_KEY) !== 'single');
  }

  // Bind on defer execution (DOM is ready) and also on DOMContentLoaded as fallback
  bindMobileSwitcher();
  document.addEventListener('DOMContentLoaded', bindMobileSwitcher);
}());

// PDP star rating (.product-rating-row, below the title/price - see
// snippets/TLPC-product.liquid, bundle-product.liquid, product.liquid)
// scrolls down to the review section on click. Delegated on document since
// the row markup is duplicated across those three snippets and can also be
// populated later by assets/judgeme-review-slider.js's fallback hydration.
// The review section is found by the "class": "jdgm-review-section" schema
// setting in sections/judgeme-review-slider.liquid, which Shopify renders as
// a class on that section's wrapping div on every product template.
(function () {
  document.addEventListener('click', function (event) {
    var ratingRow = event.target.closest('.product-rating-row');
    if (!ratingRow) return;

    var reviewSection = document.querySelector('.jdgm-review-section');
    if (!reviewSection) return;

    // scrollIntoView() was unreliable here (verified live - silently no-ops
    // on some product templates); computing the offset and calling
    // window.scrollTo() directly works consistently instead.
    var targetTop = reviewSection.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  });
}());

// Header search: while the search box is open, a click anywhere outside it
// only closes the box. Without this, the click also reached whatever was
// underneath (a link, the product image), so closing search could open a
// page. Runs in the capture phase, before the theme's own outside-click
// handler (SearchPopdown.onBodyClick in assets/theme.js), and skips while the
// mobile menu is open, as that handler does.
(function () {
  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('search-opened')) return;

    var openDetails = document.querySelector('search-popdown[data-popdown-in-header] details.is-open');
    var popdown = openDetails && openDetails.closest('search-popdown');
    if (!popdown || popdown.contains(event.target)) return;

    var header = document.querySelector('[data-site-header]');
    if (header && header.classList.contains('site-header--menu-opened')) return;

    event.preventDefault();
    event.stopPropagation();
    popdown.close();
  }, true);
}());

// Header search: every time the search box opens, start from an empty field
// with no old results. The theme's own reset (SearchForm.reset in
// assets/theme.js) sets `input.val` instead of `input.value`, so the last
// search stayed in the box. `toggle` doesn't bubble, hence the capture phase.
(function () {
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;

    var popdown = details.closest('search-popdown[data-popdown-in-header]');
    if (!popdown) return;

    var wrapper = popdown.querySelector('predictive-search, search-form');
    var input = wrapper && wrapper.input;
    if (!input) return;

    input.value = '';
    if (typeof wrapper.close === 'function') wrapper.close(true);
    if (typeof wrapper.clearResultsHTML === 'function') wrapper.clearResultsHTML();
    // Let the theme update its own "empty search" state (popular searches etc.).
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
}());

// Product-page prices amount-first with no ".00", currency after: "385 [AED
// symbol]", "385 [SAR symbol]", "385 $" on the templates
// snippets/pdp-price-attrs.liquid marks with [data-amount-first]. Liquid prints
// them that way (snippets/pdp-price.liquid), but theme.js rewrites
// [data-product-price] / [data-compare-price] in the store's money format
// ("AED 385.00", "$385.00") on every variant change - put the format back when
// it does. Symbol markup matches snippets/money-symbol.liquid.
(function () {
  var SYMBOLS = {
    AED: '<span class="currency-symbol currency-symbol--aed" role="img" aria-label="AED"></span>',
    SAR: '<span class="currency-symbol currency-symbol--sar" role="img" aria-label="SAR"></span>',
    USD: '$'
  };

  function formatPrice(el, code) {
    var amount = el.textContent.match(/\d[\d.,]*/);
    if (!amount) return; // e.g. "Free"

    var currency = SYMBOLS[code] || code;
    var html = amount[0].replace(/\.00$/, '') + '&nbsp;' + currency;
    // Already in this format (incl. the browser's own serialisation of it) -
    // skip, so the observer below doesn't loop on its own write.
    var probe = document.createElement('span');
    probe.innerHTML = html;
    if (el.innerHTML === probe.innerHTML) return;

    el.innerHTML = html;
  }

  function formatWrapper(wrapper) {
    var code = wrapper.dataset.currencyCode;
    if (!code) return;

    wrapper.querySelectorAll('[data-product-price], [data-compare-price]').forEach(function (el) {
      formatPrice(el, code);
    });
  }

  function init() {
    document.querySelectorAll('[data-price-wrapper][data-amount-first]').forEach(function (wrapper) {
      formatWrapper(wrapper);
      new MutationObserver(function () {
        formatWrapper(wrapper);
      }).observe(wrapper, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
